import React from 'react';
import Icon from '../../assets/Icon';
import { ISweepRoom } from '../../store/sweeps/types';
import { SweepStatIcon } from '../SweepItem/styles';
import { Container, DataTemplate, RoomName, RoomStat, RoomStats } from './styles';

interface Props {
    room: ISweepRoom;
}

const RoomItem: React.FC<Props> = ({ room }) => {
    const getTotalTime = (): string => {
        const totalTime = room.times.reduce((acc, time) => acc + ((time.endingAt ? time.endingAt.getTime() : new Date().getTime()) - time.beginingAt.getTime()), 0);

        const hours = Math.floor(totalTime / (1000 * 60 * 60));
        const minutes = Math.floor(totalTime / (1000 * 60)) % 60;
        const seconds = Math.floor(totalTime / 1000) % 60;

        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }
    return <Container>
        <DataTemplate>
            <RoomName>
                {room.name}
            </RoomName>

            <RoomStats>
                <RoomStat>
                    <SweepStatIcon><Icon size={20} icon={'furniture'} color={'#FFF'} /></SweepStatIcon>
                    {room.items.length}
                </RoomStat>
                <RoomStat>
                    <SweepStatIcon><Icon size={20} icon={'timer'} color={'#FFF'} /></SweepStatIcon>
                    {getTotalTime()}
                </RoomStat>
            </RoomStats>
        </DataTemplate>
    </Container>
}

export default RoomItem;